/**
 * Constants
 * */
export const moduleName = `url`;

/**
 * Reducer
 * */

export default function reducer(state = {}, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const urlSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
